<div class="container" style="display: flex;flex-direction: column;" >
<ng-container *ngIf="GID">
<button class="t-btn-popup-close" aria-label="close popup" style="z-index: 99;width: 3%;height: 3%;" matTooltip="התחלת תהליך מחדש" (click)="resetAll()"></button>

 <div class="m-box" *ngIf="!error && !showCode && !showPRN && !showRefferDoc && !success && !showName" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center;flex-direction: column;">
    <div class="w100" style="display: flex;flex-direction: column; align-items: center; justify-content: center; width: 100%;">
        <button *ngIf="!swiping" (click)="getCard()" class="blue-btn">להתחלה והעברת כרטיס מגנטי לחץ כאן</button>
        <h1 style="margin-left: 0.3em; align-self: center;" *ngIf="swiping">העבר כרטיס מגנטי כעת</h1>
        <span *ngIf="swiping" class="t-field t-field--number" style="direction: rtl;width: 20%; height: 5vh; ">
            <input #swipeField  [formControl]="card" type="password"  class="t-field-text"  />
        </span>
    </div>

</div> 
<div class="m-box" *ngIf="error" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center;flex-direction: column;">
    <div class="w100" style="display: flex;flex-direction: column; align-items: center; justify-content: center; width: 100%;">
        <h1 style="margin-left: 0.3em; align-self: center;"> לא ניתן להשלים את הפעולה</h1>
        <h1 style="margin-left: 0.3em; align-self: center;">יש לגשת למזכירות</h1>

        
    </div>

</div>
<div class="m-box" *ngIf="!error && showName" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center; flex-direction: column;">
    <div class="w100" style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%;">
        <h1 style="margin-left: 0.3em; align-self: center;">שלום  {{patient.First}} {{patient.Last}}</h1>
        <h1 style="margin-left: 0.3em; align-self: center;" *ngIf="!patient.FirstEng || !patient.LastEng"> יש להשלים את שם הפרטי והמשפחה באנגלית</h1>
        <h1 style="margin-left: 0.3em; align-self: center;"  *ngIf="patient.FirstEng && patient.LastEng"> יש לבדוק ולאשר את שם הפרטי והמשפחה באנגלית</h1>

       <div style="display: flex; flex-direction: row; justify-content: space-between;">
        <span class="t-field t-field--number" style="direction: rtl;width: 50%; height: 5vh; ">
            שם פרטי באנגלית
            <input #firstEngField [formControl]="FirstEng"   class="t-field-text" (focus)="onInputFocus(firstEngField)" (blur)="onInputBlur()" />
            
        </span>
        <span class="t-field t-field--number" style="direction: rtl;width: 50%; height: 5vh; ">
            שם משפחה באנגלית
            <input #lastEngField [formControl]="LastEng"   class="t-field-text" (focus)="onInputFocus(lastEngField)" (blur)="onInputBlur()" />            
        </span>

    </div>
    <button *ngIf="LastEng.value && FirstEng.value"  (click)="showPRN=true; showName=false;initFocus('prnField')" class="blue-btn">אשר והמשך</button>
    </div>
</div>
<div class="m-box"*ngIf="!error && showPRN" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center; flex-direction: column;">
    <div class="w100" style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%;">
        <h1 style="margin-left: 0.3em; align-self: center;">יש  לסרוק או להזין את מספר ההפנייה</h1>
        <span class="t-field t-field--number" style="direction: rtl;width: 20%; height: 5vh; ">
            <input #prnField [formControl]="PRN" class="t-field-text" (focus)="onInputFocus(prnField)" (blur)="onInputBlur()" />
        </span>
       
        <button *ngIf="PRN.value" (click)="showPRN=false; showRefferDoc=true;initFocus('refferDocField')" class="blue-btn">המשך</button>
        <div style="display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;" > 
           <h3>דוגמה:</h3> 
         <img src="../../assets/images/_prn.jpg" style="width: 50%;"/> 
        </div>
    </div>
</div>
<div class="m-box" *ngIf="!error && showRefferDoc" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center; flex-direction: column;">
    <div class="w100" style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%;">
        <h1 style="margin-left: 0.3em; align-self: center;">יש לסרוק או להזין את שם רופא המפנה</h1>
        <span class="t-field t-field--number" style="direction: rtl;width: 20%; height: 5vh; ">
            <input #refferDocField  [formControl]="RefferDoc" class="t-field-text" (focus)="onInputFocus(refferDocField )" (blur)="onInputBlur()" />
        </span>
        <div style="display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;" > 
           <h3>דוגמה:</h3> 
           <img src="../../assets/images/refDoc.jpg" style="width: 50%;"/> 
        </div>
        <button *ngIf="RefferDoc.value" (click)="showRefferDoc=false; showCode=true;initFocus('codeField')" class="blue-btn">המשך</button>
    </div>
</div>
<div class="m-box" *ngIf="!error && showCode" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center; flex-direction: column;">
    <div class="w100" style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%;">
        <h1 style="margin-left: 0.3em; align-self: center;">יש לסרוק או להזין את תז רופא המפנה</h1>
        <span class="t-field t-field--number" style="direction: rtl;width: 20%; height: 5vh; ">
            <input #codeField  [formControl]="Code" class="t-field-text" (focus)="onInputFocus(codeField )" (blur)="onInputBlur()"/>
        </span>
        <div style="display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;" > 
           <h3>דוגמה:</h3> 
           <img src="../../assets/images/code.jpg" style="width: 50%;"/> 
        </div>
      
        <button *ngIf="Code.value" (click)="endProcess();showCode=false" class="blue-btn">המשך</button>
    </div>
</div>
</ng-container>
<div class="loading-overlay" *ngIf="isLoading">
    <img
      src="../../assets/images/Wedges.svg"
      class="pdf-loader"
    />
  </div>
<div class="simple-keyboard"></div>
<div class="m-box" *ngIf="success" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center;flex-direction: column;">
    <div class="w100" style="display: flex;flex-direction: column; align-items: center; justify-content: center; width: 100%;">
        <h1 style="margin-left: 0.3em; align-self: center;">
              תהליך הקבלה הושלם בהצלחה,<br>
            צוות המרפאה מעודכן בהגעתך</h1>
        <h1 style="margin-left: 0.3em; align-self: center;">  אנא התיישב והמתן<br>
            עד שיקראו לך לתורך </h1>

    </div>

</div>
</div>